module.exports = __webpack_public_path__ + "static/media/album.6834fbb3.webp";